import React, { ReactNode } from 'react';
import {CircularProgressbar} from 'react-circular-progressbar'
import { ProgressBar } from 'react-bootstrap';
import 'react-circular-progressbar/dist/styles.css';

interface FileInfoProps {
  children: ReactNode,
}

const FileInfo: React.FC<FileInfoProps> = ({children}) => {
  return (
    <>
      {children}
    </>
  )
}

interface FileListProps {
  files: any[];
  showUploadProgress?: boolean;
  canRemoveFile?: boolean;
  removeFileBeforeSend?: Function
}

const FileList: React.FC<FileListProps> = ({files, showUploadProgress, canRemoveFile, removeFileBeforeSend}) => {
  return(
    <ul>

      {files.map((uploadedFile: any) => (
      uploadedFile.id &&
        <li key={uploadedFile.id}>
          <FileInfo>
            <div style={{margin:10}}>
              <strong> {uploadedFile.name} </strong>
              <span>{ uploadedFile.readableSize }
                {/* { !!uploadedFile.url && <button onClick={() =>{}}>Excluir</button>} */}
                {canRemoveFile && removeFileBeforeSend && (
                  <a className="btn btn-white btn-sm" style={{marginLeft: 20}} onClick={() => removeFileBeforeSend()}>
                    <i className="glyphicon glyphicon-trash"></i>
                  </a>)}
              </span>
            </div>
          </FileInfo>
          <div>
            {showUploadProgress && !uploadedFile.uploaded && !uploadedFile.error &&
              <ProgressBar variant="dark" animated now={uploadedFile.progress} label={`${uploadedFile.progress}%`}  />
            }

            { uploadedFile.uploaded && <div>OK!</div>}
          </div>
        </li>
      ))}
    </ul>
  )
}

export default FileList;
